module.exports = __webpack_public_path__ + "static/media/S_F03.154c645e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/S_F03.png
// module id = 108
// module chunks = 0